import axios from 'axios';

import { BaseUrl } from '../consts';
import { getAuthHead } from '../helpers/auth';

interface IData {
    id: string;
}

export const getAlbum = async (data: IData) => {
    const auth = await getAuthHead();
    return await axios.post(`${BaseUrl}Album/GetAlbum`, data, auth);
};
